<template>
  <div class="message-container bot-message">
    <v-avatar
      class="avatar"
      color="var(--blue-bonnet)"
      size="25px"
    >
      <span class="avatar-content">AI</span>
    </v-avatar>
    <div class="loading-dots">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.message-container {
  display: flex;
  margin-top: 20px;
  margin-right: 10px;
  margin-bottom: 0;
  width: 100%;
  align-items: center;
  gap: 15px;
  flex-shrink: 0;

  .avatar {
    flex-shrink: 0;

    .avatar-content {
      color: white;
      font-size: 10px;
      font-weight: 600;
    }
  }
}

.loading-dots {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  background: #f1f5f9;
  border-radius: 16px;
  margin-left: 0;
  max-width: fit-content;
  overflow: hidden;

  span {
    display: block;
    width: 6px;
    height: 6px;
    background-color: #64748b;
    border-radius: 50%;
    animation: bounce 1.4s infinite ease-in-out;
  }

  span:nth-child(1) {
    animation-delay: -0.32s;
  }

  span:nth-child(2) {
    animation-delay: -0.16s;
  }

  span:nth-child(3) {
    animation-delay: 0s;
  }
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
